<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="mt-2">
          <v-card-title style="color:#1f245b">Kondisi Saat Ini</v-card-title>
          <v-divider class="mx-2"></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="periodic"
                  :items-per-page="5"
                  :calculate-widths="true"
                  :mobile-breakpoint="500"
                  item-key="station"
                  class="elevation-1"
                  :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus'
                  }"
                >
                <template v-slot:[`item.time`]="{ item }">
                  {{updateTime(item.time)}}
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <span v-if="item.status==='active'">
                    <v-chip
                      color="success darken-1"
                    >
                      Aktif
                    </v-chip>
                  </span>
                  <span v-else>
                    <v-chip
                      color="error"
                    >
                      Mati
                    </v-chip>
                  </span>
                </template>
                <template v-slot:[`item.condition`]="{ item }">
                  <span v-if="item.condition==='Hujan'">
                    <v-chip
                      color="success darken-1"
                    >
                      {{item.condition}}
                    </v-chip>
                  </span>
                  <span v-else-if="item.condition==='Tidak Hujan'">
                    <v-chip
                      color="grey"
                      dark
                    >
                      {{item.condition}}
                    </v-chip>
                  </span>
                  <span v-else>
                    <v-chip
                      color="error"
                    >
                      {{item.condition}}
                    </v-chip>
                  </span>
                </template>
                <template v-slot:[`item.voltage`]="{ item }">
                  <span v-if="parseFloat(item.voltage)>parseFloat(item.batLow)">
                    <v-chip
                      color="success darken-1"
                    >
                      {{item.voltage}}
                    </v-chip>
                  </span>
                  <span v-else>
                    <v-chip
                      color="error"
                    >
                      {{item.voltage}}
                    </v-chip>
                  </span>
                </template>
                <template v-slot:[`item.signal`]="{ item }">
                  {{ item.signal > 100 ? item.signal - 100 : item.signal }}
                </template>
                </v-data-table>
                <!-- <v-dialog
                  v-model="dialog"
                  max-width="600"
                >
                  <v-card>
                    <v-toolbar
                      color="primary text-h5"
                      dark
                    >{{ station }}
                    <v-spacer></v-spacer>
                    <v-dialog
                      ref="dialog"
                      v-model="modal2"
                      :return-value.sync="time"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-col cols="6">
                        <v-text-field
                          v-model="dateRangeText"
                          label="Pick Date"
                          prepend-icon="mdi-clock-time-four-outline"
                          class="mt-6"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          
                        ></v-text-field>
                        </v-col>
                      </template>
                      <v-date-picker
                        v-if="modal2"
                        v-model="dates"
                        full-width
                        range
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="modal2 = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dialog.save(time);getData(ID)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                    </v-toolbar>

                    <v-card-text>
                      <v-tabs
                        v-model="tab"
                        background-color="transparent"
                        color="primary"
                        grow
                      >
                        <v-tab
                          v-for="item in items"
                          :key="item"
                        >
                          {{ item }}
                        </v-tab>
                      </v-tabs>

                      <v-tabs-items v-model="tab">
                        <v-tab-item>
                          <v-card
                            flat
                          >
                            <Bar
                              :chart-options="chartOptions"
                              :chart-data="chartData"
                              :height="200"
                            />
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-data-table
                              :headers="headersDetail"
                              :items="historicalDetail"
                              :items-per-page="5"
                              :calculate-widths="true"
                              :mobile-breakpoint="500"
                              item-key="station"
                              class="elevation-1"
                              :footer-props="{
                                showFirstLastPage: true,
                                firstIcon: 'mdi-arrow-collapse-left',
                                lastIcon: 'mdi-arrow-collapse-right',
                                prevIcon: 'mdi-minus',
                                nextIcon: 'mdi-plus'
                              }"
                            >
                            <template v-slot:[`item.time`]="{ item }">
                              {{updateTime(item.time)}}
                            </template>
                            </v-data-table>
                          </v-card>
                        </v-tab-item>

                      </v-tabs-items>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <download-csv
                        class   = "btn btn-default"
                        :data   = "historicalDetail"
                        :name    = "csvTitle"
                        separator-excel
                        :labels  = "labelsCSV">
                        <v-btn class="float-start mb-2" color="primary" text><v-icon left>mdi-download</v-icon>Download</v-btn>
                      </download-csv>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        text
                        @click="dialog = false"
                      >
                        Close
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog> -->
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import firebase from "firebase/app"
import { db }from "../firebase/db.js"
import moment from 'moment'
// import _ from "lodash";
// import { Bar } from 'vue-chartjs/legacy'

// import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

// ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)


  export default {
    name: 'DataPage',
    // components: { Bar },

    data: () => ({
      chartData: {
        labels: [],
        datasets: [ { label: 'Curah',data: [],backgroundColor: '#3f51b5', } ],
      },
      chartOptions: {
        responsive: true
      },
      station:'',
      dialog:false,
      headersDetail: [
          {
            text: 'Tanggal',
            align: 'start',
            value: 'tanggal',
          },
          { text: 'Curah (mm)', value: 'curah' },
        ],
      historicalDetail: [],
      headers: [
          {
            text: 'Stasiun',
            align: 'start',
            value: 'station',
          },
          { text: 'Lokasi', value: 'location' },
          { text: 'Tegangan Batre', value: 'voltage' },
          { text: 'Status Alat', value: 'status' },
          { text: 'Rekap Hari Ini (mm)', value: 'rainvol' },
          { text: 'Kondisi Saat Ini', value: 'condition' },
          { text: 'Signal(dBm)', value: 'signal' },
        ],
      condition:[],
      time: null,
      ID:null,
      modal2: false,
      data:[],
      loadingData: true,
      tab: null,
      items: [
        'Grafik', 'Tabel',
      ],
      periodic:[],
      devices:[],
      labels:[],
      datasets:[],
      offset:0,
      csvTitle:null,
      labelsCSV:{
        tanggal: 'Tanggal',
        curah: 'Curah Hujan (mm)'
      },
      infoTime:[],
      batLow:[],
    }),
    async mounted () {
      let loader = this.$loading.show()
      const date=new Date();
      let time=Date.now()/1000
      this.offset=date.getTimezoneOffset()/(-60)
      let setByLocation=false
      await db.collection('roleSetting').doc(localStorage.getItem("role")).get().then((doc)=> {
        setByLocation=doc.data().location
      })

      var deviceRef=db.collection('device')
      var periodicRef = db.collection('periodic')
      if (setByLocation) {
        deviceRef=db.collection('device').where('location','==',localStorage.getItem('location'))
        periodicRef = db.collection('periodic').where('location','==',localStorage.getItem('location'))
      }
      await deviceRef.get().then((querySnapshot) => {
        this.devices=[]
        console.log("device")
        querySnapshot.forEach((doc) => {
          if (doc.data().location=='MARNOV') {
            if (localStorage.getItem('location')=='MARNOV') {
              this.devices.push({id:doc.id,...doc.data()})
            }
          } else {
            this.devices.push({id:doc.id,...doc.data()})
          }
        });
      })
      await db.collection('setting').get().then((querySnapshot) => {
        this.infoTime=[]
        this.batLow=[]
        console.log("setting")
        querySnapshot.forEach((doc) => {
          if (doc.data().location=='MARNOV') {
            if (localStorage.getItem('location')=='MARNOV') {
              this.infoTime.push({id:doc.id, infotime:doc.data().infotime})
              this.batLow.push({id:doc.id, volt:doc.data().voltLow})
            }
          } else {
            this.infoTime.push({id:doc.id, infotime:doc.data().infotime})
            this.batLow.push({id:doc.id, volt:doc.data().voltLow})
          }
        })
      })
      deviceRef.onSnapshot((querySnapshot) => {
        this.devices=[]
        console.log("deviceSnap")
        querySnapshot.forEach((doc) => {
          if (doc.data().location=='MARNOV') {
            if (localStorage.getItem('location')=='MARNOV') {
              this.devices.push({id:doc.id,...doc.data()})
            }
          } else {
            this.devices.push({id:doc.id,...doc.data()})
          }
        });
      })
      db.collection('setting').onSnapshot((querySnapshot) => {
        this.infoTime=[]
        this.batLow=[]
        console.log("settingSnap")
        querySnapshot.forEach((doc) => {
          if (doc.data().location=='MARNOV') {
            if (localStorage.getItem('location')=='MARNOV') {
              this.infoTime.push({id:doc.id, infotime:doc.data().infotime})
              this.batLow.push({id:doc.id, volt:doc.data().voltLow})
            }
          } else {
            this.infoTime.push({id:doc.id, infotime:doc.data().infotime})
            this.batLow.push({id:doc.id, volt:doc.data().voltLow})
          }
        })
      })
      periodicRef.orderBy("time","desc").onSnapshot((collectionSnapshot) => {
        console.log("periodic")
        time=Date.now()/1000
        this.periodic=[]
        collectionSnapshot.forEach((doc) => {
          if (doc.data().location=='MARNOV') {
            if (localStorage.getItem('location')=='MARNOV') {
              this.periodic.push({id:doc.id, ...doc.data()})
            }
          } else {
            this.periodic.push({id:doc.id, ...doc.data()})
          }
        });
        for (let i=0;i<this.periodic.length;i++) {
          for (let j=0;j<this.devices.length;j++) {
            if (this.periodic[i].id==this.devices[j].id) {
              this.periodic[i].location=this.devices[j].location
              this.periodic[i].station=this.devices[j].station
              this.periodic[i].condition=this.devices[j].condition
              break;
            }
          }
        }
        let index=0
        let index2=0
        for (let i=0;i<this.periodic.length; i++) {
          index = this.infoTime.findIndex(x => x.id === this.periodic[i].id);
          index2 = this.batLow.findIndex(x => x.id === this.periodic[i].id);
          if (index>=0){
            this.periodic[i].updateTime=parseInt(this.infoTime[index].infotime)*2*60;
            if(time-parseInt(this.periodic[i].time)>this.periodic[i].updateTime) {
              this.periodic[i].status='In-Active'
              this.periodic[i].condition='N/A'
            } else {
              this.periodic[i].status='active'
            }
          }
          if (index2>=0) {
            this.periodic[i].batLow=this.batLow[index2].volt
          } 
        }
        console.log(this.periodic)
        loader.hide()
      })
    },
    methods: {
      updateTime (time) {
        return moment.unix(time).utcOffset(this.offset).format("HH:mm, DD MMM YYYY")
      },
      // clicked(item) {
      //   this.dialog=true
      //   this.station=item.station
      //   this.ID=item.id
      //   this.getData(item.id)
      // },
      // getData (id) {
      //   // this.loadingData= true
      //   if (this.dates[0]>this.dates[1]) {
      //     let temp=this.dates[0]
      //     this.dates[0]=this.dates[1]
      //     this.dates[1]=temp
      //   }
      //   this.csvTitle=`${this.station}-${this.dates[0]}~${this.dates[1]}.csv`
      //   let start = (moment(this.dates[0], "YYYY-MM-DD").valueOf()/1000).toString();
      //   let end = (moment(this.dates[1], "YYYY-MM-DD").valueOf()/1000 +86400).toString();
        
      //   var reportRef = db.collection('report').doc(id).collection('rain')
      //   reportRef.orderBy("time","desc").where("time", ">=", start).where("time", "<=", end).onSnapshot((collectionSnapshot) => {
      //     let i=0
      //     this.historicalDetail=[]
      //     this.datasets =[]
      //     this.labels=[]
      //     collectionSnapshot.forEach((doc) => {
            
      //       this.historicalDetail.push({tanggal: moment.unix(doc.data().time).utcOffset(this.offset).format("DD MMM YYYY"), curah:doc.data().rain})
      //       this.labels[i] = moment.unix(doc.data().time).utcOffset(this.offset).format("DD MMM YYYY")
      //       this.datasets[i] = doc.data().rain
      //       i++
      //     });
      //     this.chartData =  {
      //       labels: this.labels,
      //       datasets: [ { label: 'Curah',data: this.datasets,backgroundColor: '#3f51b5', } ],
      //     }
      //     // this.loadingData=false
      //   })
      // }
    },
    computed: {
      // dateRangeText () {
      //   let dateRange=[]
      //   if (this.dates[0]>this.dates[1]) {
      //     dateRange[0]=this.dates[1]
      //     dateRange[1]=this.dates[0]
      //   } else {
      //     dateRange[0]=this.dates[0]
      //     dateRange[1]=this.dates[1]
      //   }
      //   return dateRange.join(' ~ ')
      // },
    },
  }
</script>
